import script from "./AddressView.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressView.vue?vue&type=script&setup=true&lang=js"

import "./AddressView.vue?vue&type=style&index=0&id=59988188&lang=css"

const __exports__ = script;

export default __exports__